module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "first-run-sync-modal-overlay"
  }, [_c('div', {
    staticClass: "first-run-sync-modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h1', {
    staticClass: "app-title"
  }, [_vm._v("SentryKit")]), _vm._v(" "), _c('span', {
    staticClass: "user-email"
  }, [_vm._v(_vm._s(_vm.userEmail))])]), _vm._v(" "), (!_vm.syncComplete) ? _c('div', {
    staticClass: "modal-body syncing"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v("Setting up your workspace....")]), _vm._v(" "), _c('p', {
    staticClass: "modal-description"
  }, [_vm._v("\n        Syncing your Amazon catalog and setting up real-time Buy Box monitoring. Takes 2 - 5 minutes for most accounts.\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "sync-steps"
  }, _vm._l((_vm.derivedSteps), function(step, index) {
    return _c('li', {
      key: step.id,
      staticClass: "sync-step"
    }, [(step.completed) ? _c('i', {
      staticClass: "check circle icon green"
    }) : (step.inProgress) ? _c('i', {
      staticClass: "circle notch loading icon"
    }) : _c('i', {
      staticClass: "circle outline icon grey"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.completed ? step.completedLabel : step.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "progress-section"
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Item " + _vm._s(_vm.completedStepsCount) + "/" + _vm._s(_vm.derivedSteps.length) + " complete")]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-container"
  }, [_c('div', {
    staticClass: "progress-bar-fill",
    style: ({
      width: _vm.progressPercent + '%'
    })
  })])]), _vm._v(" "), _c('button', {
    staticClass: "go-to-dashboard-btn",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_vm._v("\n        Go to Dashboard\n        "), _c('i', {
    staticClass: "arrow right icon"
  })])]) : _c('div', {
    staticClass: "modal-body ready"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "ready-message"
  }, [_vm._v("All 90-day Buy Box monitoring and historic data loaded!")]), _vm._v(" "), _c('ul', {
    staticClass: "sync-steps"
  }, _vm._l((_vm.derivedSteps), function(step) {
    return _c('li', {
      key: step.id,
      staticClass: "sync-step completed"
    }, [_c('i', {
      staticClass: "check circle icon green"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(step.completedLabel))])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "go-to-dashboard-btn ready-btn",
    on: {
      "click": _vm.dismiss
    }
  }, [_c('i', {
    staticClass: "check circle icon"
  }), _vm._v("\n        Your dashboard is ready - Go to Dashboard\n      ")])]), _vm._v(" "), _c('p', {
    staticClass: "footer-text"
  }, [_vm._v("All data secured.")])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sync-complete-banner"
  }, [_c('i', {
    staticClass: "check circle icon"
  }), _vm._v(" "), _c('span', [_vm._v("Sync complete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cf6a058!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirstRunSyncModal.vue
// module id = 741
// module chunks = 2